/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { BaseQueryFn } from '@reduxjs/toolkit/query/react'
import axios, { AxiosError, AxiosRequestConfig } from 'axios'
import type { AppState } from '../../store'

export const axiosBaseQuery =
    (
        { baseUrl }: { baseUrl: string } = { baseUrl: '' }
    ): BaseQueryFn<
        {
            url: string
            method: AxiosRequestConfig['method']
            data?: AxiosRequestConfig['data']
            urlParams?: AxiosRequestConfig['params']
        },
        unknown,
        unknown
    > =>
    async ({ url, method, data, urlParams }, { getState }) => {
        try {
            const token = (getState() as AppState).user.data?.token?.access_token

            const result = await axios({
                url: baseUrl + url,
                method,
                data,
                params: urlParams,
                headers: {
                    Accept: 'application/json; charset=utf-8',
                    Platform: 'web',
                    'App-Version': process.env.NEXT_PUBLIC_VERSION,
                    Authorization: token ? `Bearer ${token}` : '',
                    'From-Web': 'true'
                },
                timeoutErrorMessage: 'The request has timed out'
            })

            if (result.status !== 200 || result.data?.hasError) {
                throw new Error(result.data.message)
            }

            return { data: result.data }
        } catch (axiosError) {
            const err = axiosError as AxiosError

            return { error: err.message }
        }
    }
